import React, { useEffect, useState } from 'react'
import { getReferredUserActivity } from '../../waitlist/services/waitlist-service';
import ReferActivities from '../../waitlist/components/ReferActivities';
import { toast } from 'react-toastify';

function ReferredActivities(props) {
    const [activity, setActivity] = useState();
    const [activityLoader, setActivityLoader] = useState(true);

    useEffect(() => {
        getReferredUserActivity().then((response) => {
            if (!response || 
                !response.success || 
                !response.data) {
                return toast.error(
                    `Error:${response.message || "No activity"}`
                );
            }
            if (response.data.activity) {
                let activities = response?.data?.activity || [];
                setActivity(activities)
                setActivityLoader(true)
            }
        });
    }, []);

    return (
        activityLoader && activity && activity.length ? (
            <ReferActivities
                referralActivity={activity}
                isMobile={props.isMobile}
            />
        ) : (
            null
        )
    )
}

export default ReferredActivities